import type { ChartOverlay } from "components/charts/modern/overlay/types";
import compareAsc from "date-fns/compareAsc";
import isAfter from "date-fns/isAfter";
import type { FlagsShapeValue, SeriesFlagsOptions } from "highcharts";
import notUndefinedOrNull from "lib/utils/notUndefinedOrNull";
import colors from "tailwindcss/colors";

export default function labelOnlyEventSeries(
  forSeriesId: string,
  overlay: ChartOverlay,
  notBefore?: Date,
): SeriesFlagsOptions {
  const { data } = overlay;
  return {
    type: "flags",
    showInNavigator: false,
    data: data
      .filter((flag) => {
        return notBefore ? isAfter(flag.x, notBefore) : true;
      })
      .map((flag) => {
        return {
          x: new Date(flag.x).getTime(),
          title: flag.title || "E",
          text: flag.label || "E",
          custom: flag,
          lineWidth: 1.5,
          fillColor: flag.theme?.backgroundColor || colors.amber[50],
          color: flag.theme?.textColor || colors.amber[600],
          style: {
            color: flag.theme?.textColor || colors.amber[600],
          },
        };
      })
      .filter(notUndefinedOrNull)
      .sort((a, b) => {
        return compareAsc(a.x, b.x);
      }),
    style: {
      fontFamily: "novel-mono-pro-condensed",
      fontSize: "12px",
    },
    custom: {
      overlay,
    },
    shape: "circle" as FlagsShapeValue,
    zIndex: 1,
    width: 16,
    height: 16,
    onSeries: forSeriesId,
    enableMouseTracking: true,
    accessibility: {
      exposeAsGroupOnly: true,
      description: "Flags indicating certain events",
    },
    states: {
      hover: {
        enabled: true,
        lineWidth: 2,
        lineColor: colors.slate[800],
        fillColor: colors.white,
      },
    },
  };
}
